import { DeleteButton } from '../../../../../components/buttons/DeleteButton';

export const MenuDayTableMealSection = ({ mealName, recipes, mealId, mealColor, onRemove }) => {

    return (
        recipes === null || recipes.filter(item => item.mealId === mealId).length === 0
            ? <></>
            : <>
                <tr align={'center'} bgcolor={mealColor}>
                    <th className={'td'} colSpan={10}>{mealName}</th>
                </tr>
                {recipes.map((recipe, index) => {
                    if (recipe.mealId === mealId) {
                        return (
                            <tr key={index}>
                                <td className={'td'} bgcolor={mealColor}> {recipe.title}</td>
                                <td className={'td'} bgcolor={mealColor}>{recipe.allProteinsCradle}</td>
                                <td className={'td'} bgcolor={mealColor}>{recipe.allProteins}</td>
                                <td className={'td'} bgcolor={mealColor}>{recipe.allFatCradle}</td>
                                <td className={'td'} bgcolor={mealColor}>{recipe.allFat}</td>
                                <td className={'td'} bgcolor={mealColor}>{recipe.allCarbohydratesCradle}</td>
                                <td className={'td'} bgcolor={mealColor}>{recipe.allCarbohydrates}</td>
                                <td className={'td'} bgcolor={mealColor}>{recipe.allEnergyValueKcalCradle}</td>
                                <td className={'td'} bgcolor={mealColor}>{recipe.allEnergyValueKcal}</td>
                                <td className={'td'} bgcolor={mealColor}><DeleteButton onClick={() => onRemove(recipe)} /></td>
                            </tr>
                        );
                    }
                })}
            </>
    );
};